<template>
  <textarea
    :value="value"
    @input="$emit('input', $event.target.value)"
    @keydown="setAutoHeight"
    :style="{height: height}"
    :id="id"
    ref="textarea"
    :class="textareaClasses"
    :name="name"
    @keydown.enter.exact.prevent
    @keyup.enter.exact="handleQuick"
  ></textarea>
</template>

<script>
import Vue from "vue";

export default {
  name: "TextArea",
  props: {
    value: {
      type: String,
      required: true
    },
    focus: {
      type: Boolean,
      default: false
    },

    /**
     * The 'id' that will be applied to the end textarea.
     */
    id: String,

    /**
     * The classes that will be applied to the end textarea.
     */
    classes: String,

    /**
     * The 'name' attribute that will be applied to the end textarea.
     */
    name: String,
    clearVal: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      height: "auto"
    };
  },

  mounted() {
    this.setAutoHeight();
  },

  created() {
    if (this.focus) {
      this.$nextTick(() => {
        this.$refs.textarea.focus();
      });
    }
  },

  computed: {
    textareaClasses() {
      return this.classes + ` v-autogrow`;
    }
  },

  methods: {
    handleQuick(e) {
      // TODO: need to somehome stop this if we are on mobile, not sure if the UX is right

      e.preventDefault();
      this.$emit("quickKey");
      if (this.clearVal) {
        e.target.value = null;
        this.height = "auto";
      }
    },
    setAutoHeight() {
      let oldHeight = this.$el.clientHeight;
      this.height = "auto";

      Vue.nextTick(() => {
        let totalHeight = this.$el.scrollHeight;
        if (oldHeight !== totalHeight) {
          this.height = `${totalHeight}px`;
        }
      });
    }
  }
};
</script>

<style scoped>
textarea {
  appearance: none;
}
.v-autogrow {
  overflow-y: hidden;
}
</style>
